import { createClient } from 'contentful';

const client = createClient({
  space: 'agq4tp8fwz31',
  accessToken: 'LtVTgimqb0XRy0Vqc1mrd6Px_wfVKVoZ_xwyd6FQXjw',
});

export default client;
